/**
 * 14세 미만인지 확인
 * @param year 년도 (문자열)
 * @param month 월 (문자열, 1-12)
 * @param day 일 (문자열)
 * @returns 14세 미만이면 true
 */
export const isUnder14 = (year: string, month: string, day: string): boolean => {
    if (year.length !== 4 || !month || !day) return false;

    const birthDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age < 14;
};

/**
 * 14세 미만인지 확인 (date string 버전)
 * @param dateString "YYYY-MM-DD" 형식의 날짜 문자열
 * @returns 14세 미만이면 true
 */
export const isUnder14FromDateString = (dateString: string): boolean => {
    if (!dateString || dateString.length !== 10) return false;

    const [year, month, day] = dateString.split('-');
    return isUnder14(year, month, day);
};
